import { FormControl, FormLabel } from '@mui/material'
import React, { useState } from 'react'
import { useActions } from '../../hooks/useActions'
import { PERSON_CONDITIONS } from '../../utils/ConditionTypes'
import { renderContent } from '../../utils/helpers'
import AddNewModal from '../../widgets/AddNewModal'
import ConditionsList from '../../widgets/ConditionsList'
import IntegerDetails from '../../widgets/IntegerDetails'
import SearchSelect from '../../widgets/SearchSelect'
import TextFieldQuestion from '../../widgets/TextFieldQuestion'

function HeartConditionDetails({ treatment, setTreatment, qualifier, setQualifier, config }) {
  const { treatmentLocation = '', patientAddress = '' } = treatment
  const { type = '' } = qualifier

  return renderContent({
    renderMap: {
      heartConditionsAge: (
        <FormControl key="hcAge">
          <FormLabel>Age at diagnosis?</FormLabel>
          <IntegerDetails
            value={type}
            onChange={(value) => setQualifier({ label: 'Age at diagnosis', type: value })}
          />
        </FormControl>
      ),
      heartConditionHospital: (
        <TextFieldQuestion
          key="hcHos"
          label="Hospital where the treatment was given?"
          value={treatmentLocation}
          handleChange={(value) => setTreatment({ ...treatment, treatmentLocation: value })}
          fullWidth
        />
      ),
      heartConditionAddress: (
        <TextFieldQuestion
          key="hcAdd"
          label="Address during treatment? (Enter town/city if unknown)"
          value={patientAddress}
          handleChange={(value) => setTreatment({ ...treatment, patientAddress: value })}
          fullWidth
        />
      ),
    },
    config,
  })
}

export default function HeartConditionsList({ personId, open, setOpen, config, heartConditions }) {
  const {
    setPersonConditions,
    setPersonConditionTreatments,
    setPersonConditionQualifiers,
    removePersonConditions,
  } = useActions()
  const [condition, setCondition] = useState({})
  const [treatment, setTreatment] = useState({})
  const [qualifier, setQualifier] = useState({})

  const heartConditionsList = PERSON_CONDITIONS.filter(({ type }) => type === 'heartConditions')

  return (
    <>
      <AddNewModal
        open={open}
        handleClose={handleClose}
        dialogTitle="Add Heart Condition"
        onSubmit={addDiagnosis}
        disabled={!('id' in condition)}
        cancelButton
      >
        <SearchSelect
          label="Search for Heart Conditions"
          value={{ value: condition.id, label: condition.label }}
          options={conditionsToOption(heartConditionsList)}
          onChange={(_, newValue) => {
            if (!newValue) {
              setCondition({})
              setTreatment({})

              return
            }
            setCondition({ id: newValue.value, label: newValue.label })
          }}
          inputLabel={'Search...'}
        />
        <HeartConditionDetails
          treatment={treatment}
          setTreatment={setTreatment}
          qualifier={qualifier}
          setQualifier={setQualifier}
          config={config}
        />
      </AddNewModal>
      <ConditionsList
        items={heartConditions}
        removeCondition={removeCondition}
        editCondition={editCondition}
      />
    </>
  )

  function conditionsToOption(conditions) {
    return conditions.map(({ id, label }) => ({
      value: id,
      label,
    }))
  }
  function removeCondition(item) {
    removePersonConditions({ id: personId, conditionId: item.id })
    handleClose()
  }
  function editCondition(item) {
    setCondition({
      id: item.id,
      label: item.label,
    })
    if (item.treatments.length) {
      setTreatment(item.treatments.find(({ type }) => type === 'other') || {})
    }
    if (item.qualifiers.length) {
      setQualifier(item.qualifiers.find(({ label }) => label === 'Age at diagnosis') || {})
    }
    setOpen(true)
  }
  function handleClose() {
    setOpen(false)
    setCondition({})
    setTreatment({})
    setQualifier({})
  }
  function addDiagnosis() {
    setPersonConditions({ id: personId, conditionId: condition.id })
    if (Object.keys(treatment).length) {
      setPersonConditionTreatments({
        id: personId,
        conditionId: condition.id,
        treatmentType: 'other',
        isPerformed: 'Y',
        value: treatment,
      })
    }
    if (Object.keys(qualifier).length) {
      setPersonConditionQualifiers({
        id: personId,
        conditionId: condition.id,
        label: qualifier.label,
        type: qualifier.type,
      })
    }
    handleClose()
  }
}
